import axios from '@axios'

const route = 'register/supply'
export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getAll(context, { itemsPerPage, page, search }) {
      return axios.get(`${route}?page=${page}&items_per_page=${itemsPerPage}&search=${search}`)
    },
    store(context, supply) {
      return axios.post(route, supply)
    },
    update(context, supply) {
      return axios.put(`${route}/${supply.id}`, supply)
    },
    delete(context, supply) {
      return axios.delete(`${route}/${supply.id}`)
    },
  },
}
